import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form"; 
import FormButton from "../FormButton";
import Input from "../Input";
import Select from "../Select";
import { useState, useEffect } from "react";
import { sendGoogleOfferHttp } from "../../http/renewalHttp/RenewalHttp"; 

export default function SendGoogleOfferModal({ offerData, handleClicked, persistedItems, setPersistedItems, ...props }) {
    const [selectedSku, setSelectedSku] = useState('');
    const [seats, setSeats] = useState('');
    const [skuDropdownOptions, setSkuDropdownOptions] = useState([]);
    const [sendOnlyCurrent, setSendOnlyCurrent] = useState(false);

    function handleClose() {
        handleClicked(false);
    }

    const handleAddSku = () => {    
        if (!selectedSku || !seats || parseInt(seats) <= 0) {
            alert("Please select an SKU and enter a valid number of seats.");
            return;
        }

        const newSkuItem = {
            sku_name: selectedSku,
            number_of_seats: parseInt(seats),
        };

        setPersistedItems(prev => [...prev, newSkuItem]);
        setSelectedSku('');
        setSeats('');
    };

    const handleRemoveSku = (indexToRemove) => {
        setPersistedItems(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    // UPDATED: Static SKU list from screenshot
    useEffect(() => {
        const skuList = [
            "Business Starter",
            "Business Standard",
            "Business Plus",
            "Enterprise Starter",
            "Enterprise Standard",
            "Enterprise Plus",
            "Frontline Starter",
            "Frontline Standard",
            "Frontline Plus",
            "Enterprise Essential",
            "Enterprise Essential Plus"
        ];

        const options = skuList.map((sku) => (
            <option key={sku} value={sku}>
                {sku}
            </option>
        ));
        
        setSkuDropdownOptions(options);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!sendOnlyCurrent && persistedItems.length === 0) { 
             alert("Please add at least one SKU or check 'Send only current SKU'.");
             return;
        }

        let existing_sku = [
            {
                skuName: offerData.skuName,
                seats : offerData.seats
            }
        ];

        const requestBody = {
            renewal_id: offerData.renewal_id,
            domain_name: offerData.domain_name,
            subscription_id: offerData.subscription_id,
            renewal_date: offerData.renewal_date,
            zoho_contact_id: offerData.zoho_contact_id,
            existing_sku : existing_sku,
            offered_skus: persistedItems, 
            send_only_current: sendOnlyCurrent
        };
        
        try {
            const response = await sendGoogleOfferHttp(requestBody); 
            if (response) { 
                alert(`Google Offer sent successfully for ${offerData.domain_name}.`);
                setPersistedItems([]);
                handleClicked(false);
            } else {
                alert(`Failed to send Google Offer: ${response.message}`);
            }
        } catch (error) {
            console.error("API Error:", error);
            alert("An error occurred while sending the offer.");
        }
    };

    return createPortal(
        <Div className="modal-backdrop">
            <dialog {...props} style={{ zIndex: 1, overflow: 'auto', margin: 'auto' }}>
                <Div className="modal-content" style={{ padding: '20px', width: '450px' }}> 
                    <Div className="form-group" style={{ fontWeight: 'bold', marginBottom: '15px' }}>Send Google Offer</Div>
                    
                    <Form onSubmit={handleSubmit}>
                        
                        {/* SKU Selection */}
                        <Div className="form-group row">
                            <label className="col-md-4 col-form-label">SKU Name:</label>
                            <Div className="col-md-8">
                                <Select
                                    name='skuName'
                                    options={skuDropdownOptions}
                                    defaultValue={selectedSku}
                                    onChange={(e) => setSelectedSku(e.target.value)}
                                    style={{ width: '100%' }}
                                    disabled={sendOnlyCurrent}
                                />
                            </Div>
                        </Div>

                        {/* Seats Input */}
                        <Div className="form-group row mb-2"> 
                            <label className="col-md-4 col-form-label">Seats:</label>
                            <Div className="col-md-8">
                                <Input
                                    type='number'
                                    name='seats'
                                    value={seats}
                                    onChange={(e) => setSeats(e.target.value)}
                                    disabled={sendOnlyCurrent}
                                />
                            </Div>
                        </Div>
                        
                        {/* Checkbox and Add Button Row (Below Seats) */}
                        <Div className="form-group row align-items-center">
                            <Div className="col-md-9 offset-md-3 d-flex justify-content-between align-items-center">
                                <div className="form-check d-flex align-items-center" style={{ marginBottom: '0' , marginLeft: '-100px'}}>
                                    <input 
                                        type="checkbox" 
                                        className="form-check-input" 
                                        id="currentOnly" 
                                        checked={sendOnlyCurrent}
                                        onChange={(e) => setSendOnlyCurrent(e.target.checked)}
                                        style={{
                                            cursor: 'pointer',
                                            width: '18px',
                                            height: '18px',
                                            border: '2px solid #333', 
                                            appearance: 'none',      
                                            borderRadius: '3px',
                                            backgroundColor: sendOnlyCurrent ? '#007bff' : '#fff',
                                            backgroundImage: sendOnlyCurrent
                                                ? `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e")`
                                                : 'none',
                                            backgroundSize: '100% 100%',
                                            marginRight: '8px'
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="currentOnly" style={{fontSize: '11px', whiteSpace: 'nowrap'}}>
                                        Send only current SKU
                                    </label>
                                </div>
                                
                                <FormButton 
                                    type='button' 
                                    className="btn btn-secondary btn-sm" 
                                    onClick={handleAddSku}
                                    disabled={sendOnlyCurrent}
                                    style={{ padding: '2px 10px' }}
                                >
                                    Add SKU
                                </FormButton>
                            </Div>
                        </Div>

                        {/* Table for added SKUs */}
                        {persistedItems.length > 0 && !sendOnlyCurrent && (
                            <Div style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px', marginTop: '10px' }}>
                                <table className="table table-striped table-sm" style={{ width: '100%', marginBottom: '0' }}>
                                    <thead>
                                        <tr>
                                            <th>SKU Name</th>
                                            <th style={{ width: '20%' }}>Seats</th>
                                            <th style={{ width: '10%' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {persistedItems.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ fontSize: '12px' }}>{item.sku_name}</td>
                                                <td style={{ fontSize: '12px' }}>{item.number_of_seats}</td>
                                                <td>
                                                    <FormButton 
                                                        type='button' 
                                                        className="btn btn-danger btn-sm" 
                                                        onClick={() => handleRemoveSku(index)}
                                                        style={{ padding: '0px 5px', lineHeight: '1.2' }}
                                                    >
                                                        x
                                                    </FormButton>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </Div>
                        )}

                        {/* Final Action Buttons */}
                        <Div className="d-flex justify-content-end mt-4">
                            <FormButton type='submit' className="btn btn-primary submit-btn">Send Offer</FormButton>
                            <FormButton type='button' className="btn btn-outline-secondary submit-btn ml-2" onClick={handleClose}>Close</FormButton>
                        </Div>
                    </Form>
                </Div>
            </dialog>
        </Div>,
        document.getElementById("modal") 
    );
}